"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var navbar_display_1 = require("../navbar/navbar-display");
var cookie_helper_1 = require("../helpers/cookie-helper");
var payout_modal_helper_1 = require("../helpers/payout-modal-helper");
var Credit = (function () {
    function Credit(api) {
        this._api = api;
        this._navbar = new navbar_display_1.default();
    }
    Credit.prototype.getCredit = function (user) {
        var _this = this;
        if (user.isLogggedIn()) {
            this._api.send('/user/get-credit', { 'username': cookie_helper_1.default.get('uName') }, function (response) {
                if (response.Status !== 1) {
                    console.log('Get Credit Failed. No response data.');
                }
                else {
                    user.username = cookie_helper_1.default.get('uName');
                    _this._navbar.showUpdatedCredit(user, response);
                    console.log('Credit updated.');
                }
            }, function () {
                console.log('Get Credit Failed.');
            });
        }
        else {
            var logoutEvent = new CustomEvent("logout");
            window.dispatchEvent(logoutEvent);
        }
    };
    Credit.prototype.getAsyncCredit = function (user) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (user.isLogggedIn()) {
                _this._api.send('/user/get-credit', { 'username': cookie_helper_1.default.get('uName') }, function (response) {
                    if (response.Status !== 1) {
                        console.log('Get Credit Failed. No response data.');
                    }
                    else {
                        resolve(response.Credit);
                    }
                }, function () {
                    console.log('Get Credit Failed.');
                    reject('Get Credit Failed.');
                });
            }
            else {
                var logoutEvent = new CustomEvent("logout");
                window.dispatchEvent(logoutEvent);
            }
        });
    };
    Credit.prototype.requestPayout = function (user) {
        if (user.isLogggedIn()) {
            this._api.send('/user/request-payout', { 'username': cookie_helper_1.default.get('uName') }, function (response) {
                if (response.Status !== 1) {
                    console.log('Payout Failed. No response data.');
                }
                else {
                    payout_modal_helper_1.default.openModal();
                    payout_modal_helper_1.default.bind(response.PayoutPIN);
                }
            }, function () {
                console.log('Get Credit Failed.');
            });
        }
        else {
            var logoutEvent = new CustomEvent("logout");
            window.dispatchEvent(logoutEvent);
        }
    };
    return Credit;
}());
exports.default = Credit;



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/ts/credit/credit.ts
// module id = 1995
// module chunks = 6